import {gsap} from "gsap";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {NineToFive} from "../../NineToFive";
import {NineToFiveXWaysSymbol} from "../../reels/symbols/XWaysSymbol";


/**
 * Created by jonas on 2022-01-12.
 */

export class RevealXWays implements SimplePresentation {

    name:string = "RevealXWays";

    constructor() {
    }

    shouldRun():boolean {
        return this.getXWaysSymbols().length > 0
    }

    private getXWaysSymbols():NineToFiveXWaysSymbol[] {
        return <NineToFiveXWaysSymbol[]>NineToFive.baseGameReelView.getAllSymbols().filter((sym) => sym.symbolName == "XW");
    }

    start(controller:SimplePresentationRunnerController):void {
        const tl = gsap.timeline({
            onComplete: () => {
                controller.setSkipCallback();
                controller.finish()
            }
        })
            .add(() => {controller.setSkipCallback(() => {tl.seek("End", false)})}, "<")
            .add(this.getXWaysSymbols().map((sym) => sym.xWaysReveal()))
            .add(() => {NineToFive.soundPlayer.playSound("xWaysReveal")}, '<')
            .addLabel("End")
            .add(() => {}, '>0.3');
    }
}
